import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import type { LoaderData } from "./SharedLiveStatusPage";
import { SharedLiveStatusPage, sharedLiveStatusPageLoader } from "./SharedLiveStatusPage";
export const tenantedApplicationLiveStatusPageLoader = sharedLiveStatusPageLoader;
interface TenantedApplicationLiveStatusPageProps {
    loaderData: LoaderData;
    project: ProjectResource;
    tenantId: string;
}
export function TenantedApplicationLiveStatusPage({ loaderData, project, tenantId }: TenantedApplicationLiveStatusPageProps) {
    return <SharedLiveStatusPage loaderData={loaderData} project={project} tenantId={tenantId}/>;
}
